import { createSlice } from '@reduxjs/toolkit';
import reducer from './reducer';

const initialState = {
  list: [],
  viewItem: undefined,
  optionsFlow: []
};

export default createSlice({
  name: 'selects',
  initialState: initialState,
  reducers: reducer,
});
